import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/authSlice";
import moment from "moment";
import "moment/locale/ar";

export default function NavbarUserMenu() {
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Get user data from Redux state
  const { name, isOnline, title } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Format current date and time for "last seen"
  const formatCurrentDateTime = () => {
    return moment().locale("ar").format("DD/MM/YYYY - hh:mm A");
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfile = () => {
    handleMenuClose();
    navigate("/profile");
  };

  const handleLogout = () => {
    handleMenuClose();
    dispatch(logout());
    navigate("/login");
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Create user display name with title if available
  const displayName = title ? `${title} ${name || ""}` : name || "المستخدم";

  const renderMenu = (
    <Menu
      disableScrollLock
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id="primary-search-account-menu"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {isMobile && (
        <MenuItem onClick={handleMenuClose}>
          مرحبا
          <br />
          {displayName}
        </MenuItem>
      )}

      {isMobile && (
        <MenuItem onClick={handleMenuClose}>
          اخر ظهور
          <br />
          {formatCurrentDateTime()}
        </MenuItem>
      )}

      <MenuItem onClick={handleProfile}>الملف الشخصي</MenuItem>
      <MenuItem
        onClick={() => (window.location.href = "https://houfalmanazel.com/")}
      >
        الذهاب الي الموقع
      </MenuItem>
      <MenuItem onClick={handleLogout}>تسجيل الخروج</MenuItem>
    </Menu>
  );

  return (
    <Box>
      <Box
        sx={{
          display: { md: "flex" },
        }}
      >
        <IconButton
          size="large"
          aria-label="show new notifications"
          color="inherit"
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          {/* <Badge badgeContent={3} color="error">
            <NotificationsIcon />
          </Badge> */}
        </IconButton>

        <IconButton
          size="large"
          edge="end"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          {/* Use first letter of name for avatar if available */}
          <Avatar
            sx={{
              marginLeft: 1,
              bgcolor: isOnline ? "success.main" : "grey.500",
            }}
          >
            {name ? name.charAt(0).toUpperCase() : "U"}
          </Avatar>

          {!isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "14px",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span className="name-with-arrow">{displayName}</span>
              </div>
              <span>
                {isOnline ? "متصل الآن" : `اخر ظهور ${formatCurrentDateTime()}`}
              </span>
            </div>
          )}
        </IconButton>
      </Box>
      {renderMenu}
    </Box>
  );
}
